import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { DataTablesModule } from 'angular-datatables';
import { LoaderComponent } from '../Component/Loader/loader/loader.component';
import { ApprovalMatrixService } from '../Model/ApprovalMatrix/approval-matrix.service';
import { SessionService } from '../Util/Session/session.service';
import { ToastService, toastTypeEnum } from '../Util/Toast/toast.service';
import { CommonService } from '../Model/Common/common.service';
import { CustomDateParserFormatter } from '../Util/DateFormat/date-format.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CompensatoryOffService } from '../Model/CompensatoryOff/compensatory-off.service';
import { TooltipService } from '../Util/Tooltip/tooltip.service';
import { UserRightService } from '../Model/UserRight/user-right.service';
import { ConfirmationComponent } from '../Component/Confirmation/confirmation/confirmation.component';
import { AlertSuccessComponent } from '../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../Component/Alert/alert-warning/alert-warning.component';

@Component({
  selector: 'app-admin-compoff-consume-detail',
  standalone: true,
  imports: [CommonModule, DataTablesModule, FormsModule, RouterModule, LoaderComponent],
  templateUrl: './admin-compoff-consume-detail.component.html',
  styleUrl: './admin-compoff-consume-detail.component.scss'
})
export class AdminCompoffConsumeDetailComponent {

  @Input() EmployeeId = 0;
  @Input() EmpType = '';
  @Input() TransactionId = 0;

  isDisabled: boolean = false;
  isSuper: boolean = false;//for super admin
  GetID = 0;//1-detail,2-request
  isApprovalLavel = true;

  DetailData = {
    WebESSApprovalRequestTrackingId: null as any,
    TransactionId: null,
    EmpMasterId: null,
    EmpCode: null,
    Photo: null as any,
    EmployeeName: null as any,
    BranchName: null,
    ClientLocation: null,
    DesignationMasterId: null,
    DesignationName: null,
    ShiftMasterID: null,
    ShiftTitle: null,
    CompOffRequestDate: null,
    LeaveFromDate: null,
    LeaveToDate: null,
    HalfDay: null,
    HalfDaySession: null,
    NoOfDays: null,
    Reason: null,
    EmpType: null as any,
    ApprovalStatus: null as any,
  };
  Trackings = [];
  TrackingsUser = [];
  user = [] as any;

  Filter = {
    ModuleMasterId: 14,
    WebESSApprovalRequestTrackingId: 0,
    FromDate: null,
    ToDate: null,
    FromDateObj: null as any,
    ToDateObj: null as any,
    EmpMasterId: 0,
    EmpMappingId: 0,
    SelectType1: 'D',
    SelectType: null,
    TransactionId: 0,
    EmpType: null,
    Remark: null,
    isShowError: false,
  }

  constructor(
    private approvalMatrix: ApprovalMatrixService,
    private route: ActivatedRoute,
    private session: SessionService,
    private toast: ToastService,
    private router: Router,
    protected common: CommonService,
    protected dateFormate: CustomDateParserFormatter,
    private modalService: NgbModal,
    private compensatoryoff: CompensatoryOffService,
    protected tooltip: TooltipService,
    private userright: UserRightService,
    private activeModal: NgbActiveModal
  ) {
    // this.common.getPageRights();
    // this.user = this.session.GetUserDetails();
    // this.route.params.subscribe(params => this.Filter.WebESSApprovalRequestTrackingId = parseInt(params['id']));
    // if (window.location.pathname.includes('todo')) {
    //   this.GetID = 1;
    // } else if (window.location.pathname.includes('request')) {
    //   this.GetID = 2
    // }
    
    this.user = this.session.GetUserDetails();
    this.GetID = 2;
  }

  ngOnInit(): void {
    // if (this.user.UserType == 'E') {
    //   this.Filter.EmpMappingId = this.user.UserId;
    // }
    // if (this.GetID == 1) {
    //   this.ApprovalMatrixRequestGet();
    //   //if (this.user.UserType == 'A') {
    //   this.ESS_GetUserRole();
    //   //}
    // } else if (this.GetID == 2) {
    //   this.ESS_EmployeeCompOffConsumeLoad();
    // }
    this.Filter.WebESSApprovalRequestTrackingId = this.TransactionId;
    this.Filter.EmpMasterId = this.EmployeeId;
    this.ESS_EmployeeCompOffConsumeLoad();
  }

  ApprovalMatrixRequestGet() {
    this.isDisabled = true;
    this.approvalMatrix.ApprovalMatrixRequestGet(this.Filter).subscribe({
      next: (response) => {
        if (this.Filter.ModuleMasterId == 14) {
          if (response.Table.length > 0) {
            this.DetailData = response.Table[0];
          } else if (response.Table1.length > 0) {
            this.DetailData = response.Table1[0];
          } else if (response.Table2.length > 0) {
            this.DetailData = response.Table2[0];
          } else if (response.Table3.length > 0) {
            this.DetailData = response.Table3[0];
          }
        }
        this.isDisabled = false;
      },
      complete: () => {
        this.ApprovalMatrixRequestGetTracking();
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ApprovalMatrixRequestGetTracking() {
    this.isDisabled = true;
    this.approvalMatrix.ApprovalMatrixRequestGet({ ModuleMasterId: this.Filter.ModuleMasterId, FromDate: '', ToDate: '', EmpMasterId: this.DetailData.EmpMasterId, EmpMappingId: this.Filter.EmpMappingId, SelectType1: 'ApprovalStatus', SelectType: '', TransactionId: this.DetailData.TransactionId }).subscribe({
      next: (response) => {
        if (response.Table.length == 0) {
          this.isApprovalLavel = false;
        }
        if (this.common.ToLowerCase(this.DetailData.ApprovalStatus) == 'pending') {
          // if (this.user.UserType == 'A') {
          //   this.TrackingsUser = response.Table.filter((e: any) => e.ApproverId == this.user.UserId);
          //   this.Trackings = response.Table.filter((e: any) => e.ApproverId != this.user.UserId).sort((a: any, b: any) => b['SrNo.'] - a['SrNo.']);
          // } else if (this.user.UserType == 'E') {
            this.TrackingsUser = response.Table.filter((e: any) => e.EmpApproverId == this.EmployeeId);
            this.Trackings = response.Table.filter((e: any) => e.EmpApproverId != this.EmployeeId).sort((a: any, b: any) => b['SrNo.'] - a['SrNo.']);
          // }
        } else {
          this.Trackings = response.Table.sort((a: any, b: any) => b['SrNo.'] - a['SrNo.']);
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ApprovalMatrixRequestProcess(SelectType: string) {
    if (((SelectType == 'Reject' && this.Filter.Remark != '' && this.Filter.Remark != null) || SelectType == 'Approve') || this.isSuper) {
      const modalRef = this.modalService.open(ConfirmationComponent, {
        size: 'md',
        backdrop: 'static',
        centered: true,
        windowClass: 'confirmation-modal'
      });
      modalRef.componentInstance.Message = 'Do you want to ' + SelectType + '?';
      modalRef.result.then((result: any) => {
        if (result) {
          this.isDisabled = true;
          //this.approvalMatrix.ApprovalMatrixRequestProcess({ SelectType: SelectType, WebESSApprovalRequestTrackingId: this.DetailData.WebESSApprovalRequestTrackingId, Remark: this.Filter.Remark, approvedid: this.DetailData.EmpMasterId, EmpMappingId: this.Filter.EmpMappingId, }).subscribe({
          this.approvalMatrix.ApprovalMatrixRequestProcess({ SelectType: SelectType, WebESSApprovalRequestTrackingId: this.DetailData.WebESSApprovalRequestTrackingId, Remark: this.Filter.Remark, EmpMappingId: this.Filter.EmpMappingId, }).subscribe({
            next: (response) => {
              if (response.Error_Code == '49' || response.Error_Code == '50' || response.Error_Code == '51') {
                const modalRef = this.modalService.open(AlertSuccessComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => {
                  if (result) {
                    this.Cancel();
                  }
                });
              } else {
                const modalRef = this.modalService.open(AlertWarningComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => { });
              }
              this.isDisabled = false;
            },
            complete: () => { },
            error: (error) => {
              this.isDisabled = false;
            },
          });
        }
      }).catch(() => { });
    } else {
      this.Filter.isShowError = true;
      this.toast.show({ message: 'Please enter remark', type: toastTypeEnum.warning });
    }
  }

  ESS_EmployeeCompOffConsumeLoad() {
    this.isDisabled = true;
    this.compensatoryoff.ESS_EmployeeCompOffConsumeLoad({ ESS_EmployeeCompOffConsumeId: this.Filter.WebESSApprovalRequestTrackingId, EmpMasterID: this.EmployeeId, FromDate: null, ToDate: null, ApprovalStatus: "ALL", SelectType: 4 }
    ).subscribe({
      next: (response) => {
        console.log(response);
        this.DetailData.WebESSApprovalRequestTrackingId = 0,
          this.DetailData.TransactionId = response.Table[0].TransactionId,
          this.DetailData.EmpMasterId = response.Table[0].EmpMasterID,
          this.DetailData.EmpCode = response.Table[0].EmpCode,
          this.DetailData.Photo = response.Table[0].Photo,
          this.DetailData.EmployeeName = response.Table[0].FullName,
          this.DetailData.BranchName = response.Table[0].BranchName,
          this.DetailData.ClientLocation = response.Table[0].ClientLocation,
          this.DetailData.DesignationMasterId = response.Table[0].DesignationMasterID,
          this.DetailData.DesignationName = response.Table[0].DesignationName,
          this.DetailData.ShiftMasterID = response.Table[0].DesignationName,
          this.DetailData.ShiftTitle = response.Table[0].ShiftTitle,
          this.DetailData.CompOffRequestDate = response.Table[0].CompOffRequestDate,
          this.DetailData.LeaveFromDate = response.Table[0].LeaveFromDate,
          this.DetailData.LeaveToDate = response.Table[0].LeaveToDate,
          this.DetailData.HalfDay = response.Table[0].HalfDay,
          this.DetailData.HalfDaySession = response.Table[0].HalfDaySession,
          this.DetailData.NoOfDays = response.Table[0].NoOfDay,
          this.DetailData.Reason = response.Table[0].Reason,
          this.DetailData.EmpType = this.EmpType,
          this.DetailData.ApprovalStatus = response.Table[0].ApprovalStatus,
          this.isDisabled = false;
        console.log(this.DetailData.ApprovalStatus)
      },
      complete: () => {
        this.ApprovalMatrixRequestGetTracking();
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  Link(Text: string) {
    return this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + 'EmployeeLeaveAttachment' + '/' + Text;
  }

  Cancel() {
    // if (this.GetID == 1) {
    //   if (this.user.UserType == 'A') {
    //     this.router.navigate(['/todo/compensatoryoffconsumeapproval/']);
    //   } else if (this.user.UserType == 'E') {
    //     this.router.navigate(['/request/compensatoryoffconsume/approval/']);
    //   }
    // } else if (this.GetID == 2) {
    //   this.router.navigate(['/request/compensatoryoffconsume/']);
    // }
    this.activeModal.close(true);
  }

  ESS_GetUserRole() {
    this.isDisabled = true;
    try {
      this.userright.ESS_GetUserRole({ SelectType: 'S', EmpMappingId: this.Filter.EmpMappingId, }).subscribe({
        next: (response) => {
          if (this.common.ToLowerCase(response.Table[0].UserRole) == 'superadmin') {
            this.isSuper = true;
          }
          this.isDisabled = false;
        },
        complete: () => { },
        error: (error) => {
          this.isDisabled = false;
        },
      });
    } catch (e) {
      this.isDisabled = false;
    }
  }

  removeError() {
    this.Filter.isShowError = false;
  }

  SaveEmployeeCompOffDetails() {
    const modalRef = this.modalService.open(ConfirmationComponent);
    modalRef.componentInstance.Message = 'Do you want to withdraw?';
    modalRef.result.then(result => {
      if (this.common.PageRight.IsAdd) {
        if (result) {
          this.isDisabled = true;
          this.compensatoryoff.EmployeeCompOffConsumeSave({ 
            SelectType: 'WITHDRAWN', 
            ESS_EmployeeCompOffConsumeId: this.Filter.WebESSApprovalRequestTrackingId,
            // IsAdminWithdrawn: true,
            // AdminWithdrawnRequestBy: this.user.UserId
          }).subscribe({
            next: (response) => {
              if (response.Error_Code == '493') {
                const modalRef = this.modalService.open(AlertSuccessComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => {
                  if (result) {
                    this.Cancel();
                  }
                });
              } else {
                const modalRef = this.modalService.open(AlertWarningComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => { });
              }
              this.isDisabled = false;
            },
            complete: () => { },
            error: (error) => {
              this.isDisabled = false;
            },
          });
        }
      } else {
        // this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      }
    });
  }

}
